import React, { useEffect, useState } from 'react'
import _ from 'lodash';

import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectGlobalDbnTaxonomySubDomainAttributesListItems, selectGlobalDbnTaxonomySubDomainAttributesQueryItems } from '../../../../redux/global-dbn-taxonomy-sub-domain-attributes/selector';
import { globalDbnTaxonomySubDomainAttributes } from '../../../../redux/global-dbn-taxonomy-sub-domain-attributes/action';
import PageLoader from '../../../../components/PageLoader';
import { GlobalDbnTaxonomySubDomainAttributeComponent } from '../components/global-dbn-taxonomy-sub-domain-attribute.component';
import { globalDbnTaxonomyDomains } from '../../../../redux/global-dbn-taxonomy-domains/action';
import { selectGlobalDbnTaxonomyDomainsListItems } from '../../../../redux/global-dbn-taxonomy-domains/selector';
import { selectListItems } from '../../../../redux/library/selector';


const GlobalDbnTaxonomySubDomainAttribute = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const libraryData = useSelector(selectListItems)

    const listGlobalDbnTaxonomyDomainData = useSelector(selectGlobalDbnTaxonomyDomainsListItems)
  
  const querySubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesQueryItems)
  const listSubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const [isQuery, setIsQuery] = useState<boolean>(false)
  
  const parentSubDomainAttribute = listSubDomainAttributesData?.result?.items.filter(
    (subSubDomainAttributeData: any) => subSubDomainAttributeData.IsSubSubDomainAttribute === false
  )
  const fetchGlobalDbnTaxonomySubDomainAttributeById = () => {
    dispatch(globalDbnTaxonomySubDomainAttributes.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attributes/dbn-fetch-detail`, entity: 'globalDbnTaxonomySubDomainAttributes', jsonData: {
        Records: [
          {
            "Id": parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })




  }


  const fetchGlobalDbnTaxonomyDomains = async () => {
      await dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'list' }))
      dispatch(globalDbnTaxonomyDomains.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`, entity: 'GlobalDbnTaxonomyDomains', jsonData:
        {
          "Context": {},
          "Records": [
              {
                  "IsSubDomain": true 
              }
          ],
          "Pagination": {
            // "PageNumber": pageData,
            // "PageSize": pageSize,
            "SortField": "DBNSubDomainAttributeId",
            "SortOrder": "desc",
          }
        }
      }))
    }

  useEffect(() => {
    console.log('querySubDomainAttributesData', querySubDomainAttributesData)
  }, [querySubDomainAttributesData]);

  useEffect(() => {
    fetchGlobalDbnTaxonomyDomains();
  }, []);

  useEffect(
    () => {
      dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'list' })).then(() => {
        dispatch(globalDbnTaxonomySubDomainAttributes.list({
          url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attributes/dbn-fetch`, entity: 'globalDbnTaxonomySubDomainAttributes', jsonData: {
          }
        })).then(() => {
          if (parmas?.id > 0) {
            fetchGlobalDbnTaxonomySubDomainAttributeById()
            setIsLoading(false)
          }
          else {
            setIsLoading(false)
          }
        })
      })
    }, [])


  const handleSave = async (data: any) => {
    // data will come as an array of objects
    if (parmas?.id > 0) {    
      await dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'update' }))
      await dispatch(globalDbnTaxonomySubDomainAttributes.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attributes`, entity: 'globalDbnTaxonomySubDomainAttributes', jsonData: {
          Context: {},
          Records: data
        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(globalDbnTaxonomySubDomainAttributes.resetAction({ actionType: 'create' }))      
      await dispatch(globalDbnTaxonomySubDomainAttributes.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attributes`, entity: 'globalDbnTaxonomySubDomainAttributes', jsonData: {
          Context: {},
          Records: data
        }
      })).then(() => {
        back()
      })
    }

  }

  const back = () => {
    navigate(-1)
  }

  return (
    <>
      {isLoading || 
      listGlobalDbnTaxonomyDomainData?.isLoading ||
      querySubDomainAttributesData?.isLoading ? <PageLoader /> :
        <GlobalDbnTaxonomySubDomainAttributeComponent
          // selectedSubDomainAttribute={selectedSubDomainAttribute}
          // parentSubDomainAttribute={parentSubDomainAttribute}
          attributes={[querySubDomainAttributesData?.result?.items]}
          subDomains={listGlobalDbnTaxonomyDomainData?.result?.items}
          libraryData={libraryData}
          back={back}
          handleSave={handleSave}
          // id={parmas?.id}
        //  functionAttributes={functionAttributes}
        //  setFunctionAttributes={setFunctionAttributes}
        />
      }
    </>
  )

}

export default GlobalDbnTaxonomySubDomainAttribute;
